import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[onlyNumbers]'
})
export class OnlyNumbersDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const regex = new RegExp('^[0-9]*$'); // Nur Zahlen erlaubt
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) blockPaste(event: ClipboardEvent) {
    event.preventDefault();
  }
}